import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import { vendorsAPI, auditLogsAPI } from '../../api/config';
import {
  fetchVendorsSuccess,
  fetchVendorsFailure,
  createVendorSuccess,
  createVendorFailure,
  updateVendorSuccess,
  updateVendorFailure,
  fetchVendorSuccess,
  fetchVendorFailure,
} from '../actions/vendorActions';

function* fetchVendorsSaga() {
  try {
    const response = yield call(vendorsAPI.fetchVendors);
    // New API returns { vendors: [...], count: number }
    yield put(fetchVendorsSuccess(response.data.vendors || response.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch vendors';
    yield put(fetchVendorsFailure(errorMessage));
    message.error(errorMessage);
  }
}

function* createVendorSaga(action) {
  try {
    const response = yield call(vendorsAPI.createVendor, action.payload);
    // New API returns { message: "...", vendor: {...} }
    const vendor = response.data.vendor || response.data;
    yield put(createVendorSuccess(vendor));
    message.success(response.data.message || 'Vendor created successfully');
    // Log vendor creation
    yield call(auditLogsAPI.createAuditLog, {
      entityType: 'vendor',
      entityId: vendor.id,
      changeType: 'create',
      newData: vendor
    });
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to create vendor';
    yield put(createVendorFailure(errorMessage));
    message.error(errorMessage);
  }
}

function* updateVendorSaga(action) {
  try {
    const { id, vendorData } = action.payload;
    const oldVendorResponse = yield call(vendorsAPI.getVendor, id);
    const oldVendor = oldVendorResponse.data.vendor || oldVendorResponse.data;
    const response = yield call(vendorsAPI.updateVendor, id, vendorData);
    const updatedVendor = response.data.vendor || response.data;
    yield put(updateVendorSuccess(updatedVendor));
    message.success(response.data.message || 'Vendor updated successfully');
    // Log vendor update
    yield call(auditLogsAPI.createAuditLog, {
      entityType: 'vendor',
      entityId: id,
      changeType: 'update',
      oldData: oldVendor,
      newData: updatedVendor
    });
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to update vendor';
    yield put(updateVendorFailure(errorMessage));
    message.error(errorMessage);
  }
}

function* fetchVendorSaga(action) {
  try {
    const response = yield call(vendorsAPI.getVendor, action.payload);
    const vendor = response.data.vendor || response.data;
    yield put(fetchVendorSuccess(vendor));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Failed to fetch vendor details';
    yield put(fetchVendorFailure(errorMessage));
    message.error(errorMessage);
  }
}


export default function* vendorSaga() {
  yield takeLatest(types.FETCH_VENDORS_REQUEST, fetchVendorsSaga);
  yield takeLatest(types.FETCH_VENDOR_REQUEST, fetchVendorSaga);
  yield takeLatest(types.CREATE_VENDOR_REQUEST, createVendorSaga);
  yield takeLatest(types.UPDATE_VENDOR_REQUEST, updateVendorSaga);
}